import axios from "axios";

const http = axios.create({
    baseURL: "/api"
});

http.interceptors.response.use(res => res, err => {
    if (err.response.status === 401) {
        window.location.href = `/login.aspx?ReturnUrl=${process.env.VUE_APP_RETURN_URL}`;
    }
    throw err;
});

export { http };
